let map: google.maps.Map;
const markers: google.maps.marker.AdvancedMarkerElement[] = [];

async function initMap(): Promise<void> {
  // The location of MUSTARD HOTEL
  const position = { lat: 35.66459103272382, lng: 139.67118311931145 };

  // Request needed libraries.
  const { Map } = (await google.maps.importLibrary(
    'maps'
  )) as google.maps.MapsLibrary;
  const { AdvancedMarkerElement } = (await google.maps.importLibrary(
    'marker'
  )) as google.maps.MarkerLibrary;

  const mqlLg = window.matchMedia('(min-width: 1024px)');

  const mapElement = mqlLg.matches ? document.getElementById('map') : document.getElementById('map-mobile');

  map = new Map(mapElement as HTMLElement, {
    center: position,
    zoom: 15,
    mapTypeControl: false,
    mapId: 'e78a40557ee694af',
  });

  const placeData = document.querySelectorAll('.js-place-data');

  const pinName = document.getElementById('pin-name');
  const pinTitle = document.getElementById('pin-title');
  const pinThumbnail = document.getElementById('pin-thumbnail');

  const musterdPin = '<svg class="w-[2.75rem]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 57.15 57.15"><path d="M28.57,54.65c-3.52,0-6.94-.69-10.15-2.05-3.1-1.31-5.89-3.19-8.29-5.59-2.4-2.4-4.28-5.18-5.59-8.29-1.36-3.21-2.05-6.63-2.05-10.15s.69-6.94,2.05-10.15c1.31-3.1,3.19-5.89,5.59-8.29,2.4-2.4,5.18-4.28,8.29-5.59,3.21-1.36,6.63-2.05,10.15-2.05s6.94.69,10.15,2.05c3.1,1.31,5.89,3.19,8.29,5.59,2.4,2.4,4.28,5.18,5.59,8.29,1.36,3.21,2.05,6.63,2.05,10.15s-.69,6.94-2.05,10.15c-1.31,3.1-3.19,5.89-5.59,8.29s-5.18,4.28-8.29,5.59c-3.21,1.36-6.63,2.05-10.15,2.05Z" fill="#222" stroke-width="0"/><path d="M28.57,5c-3.18,0-6.27.62-9.17,1.85-2.81,1.19-5.33,2.89-7.49,5.05-2.17,2.17-3.87,4.69-5.05,7.49-1.23,2.9-1.85,5.99-1.85,9.17s.62,6.27,1.85,9.17c1.19,2.81,2.89,5.33,5.05,7.49,2.17,2.17,4.69,3.87,7.49,5.05,2.9,1.23,5.99,1.85,9.17,1.85s6.27-.62,9.17-1.85c2.81-1.19,5.33-2.89,7.49-5.05,2.17-2.17,3.87-4.69,5.05-7.49,1.23-2.9,1.85-5.99,1.85-9.17s-.62-6.27-1.85-9.17c-1.19-2.81-2.89-5.33-5.05-7.49-2.17-2.17-4.69-3.87-7.49-5.05-2.9-1.23-5.99-1.85-9.17-1.85M28.57,0c15.78,0,28.57,12.79,28.57,28.57s-12.79,28.57-28.57,28.57S0,44.35,0,28.57,12.79,0,28.57,0Z" fill="#222" stroke-width="0"/><path d="M5.2,28h-1.26v-6.48h1.97l1.18,5.09,1.17-5.09h1.94v6.48h-1.26v-5.44l-1.21,5.44h-1.31l-1.22-5.44v5.44ZM15.02,25.5v-3.98h1.38v3.98c.03.55-.08,1.11-.32,1.61-.5.76-1.38,1.17-2.28,1.06-.9.11-1.79-.3-2.29-1.06-.24-.5-.35-1.06-.32-1.61v-3.98h1.38v3.98c-.02.33.03.67.16.98.21.39.64.61,1.07.55.44.06.86-.16,1.07-.55.12-.31.18-.65.16-.98h0ZM19.77,27.06c.26,0,.53-.03.78-.11.34-.09.58-.4.57-.75,0-.21-.1-.4-.28-.5-.28-.15-.57-.25-.88-.3l-.69-.15c-.49-.08-.97-.25-1.4-.5-.45-.32-.7-.85-.65-1.4-.01-.55.22-1.08.63-1.45.53-.42,1.19-.62,1.86-.58.63-.02,1.24.17,1.75.54.49.37.77.96.76,1.57h-1.3c0-.35-.2-.67-.51-.83-.25-.12-.52-.17-.79-.16-.29-.01-.58.06-.84.21-.2.13-.32.35-.31.59,0,.22.11.42.31.52.27.12.55.21.84.27l1.12.27c.4.08.78.24,1.11.47.39.32.61.81.58,1.32.01.57-.23,1.12-.67,1.48-.55.42-1.23.63-1.92.59-.71.04-1.41-.16-1.99-.58-.48-.38-.75-.97-.72-1.59h1.29c.02.24.1.47.24.66.3.3.71.44,1.13.4h0ZM27.86,21.52v1.15h-1.93v5.34h-1.36v-5.33h-1.95v-1.15h5.24ZM31.51,26.66h-2.38l-.45,1.34h-1.41l2.31-6.48h1.53l2.3,6.48h-1.47l-.42-1.34ZM31.13,25.55l-.81-2.55-.84,2.55h1.64ZM36.7,25.46h-1.4v2.54h-1.32v-6.48h3.18c.36,0,.71.05,1.04.17.24.1.45.25.62.45.14.16.25.35.33.55.09.22.13.45.12.68,0,.32-.08.63-.23.91-.16.3-.44.53-.77.63.26.09.49.27.64.51.14.32.21.67.19,1.01v.43c0,.2,0,.4.03.6.03.15.12.29.25.37v.17h-1.49c-.04-.14-.07-.26-.09-.35-.04-.18-.05-.37-.06-.56v-.6c.02-.29-.06-.59-.23-.83-.24-.17-.53-.24-.81-.21ZM37.52,24.28c.27-.13.43-.43.4-.73.04-.32-.11-.63-.39-.79-.21-.09-.43-.13-.66-.11h-1.57v1.74h1.53c.23.01.47-.02.69-.11ZM42.97,28h-2.79v-6.48h2.79c.34,0,.68.04,1,.14.45.15.83.43,1.1.82.22.31.38.67.46,1.05.08.35.12.71.13,1.07.02.76-.16,1.52-.52,2.19-.43.79-1.27,1.26-2.17,1.21ZM43.97,23.18c-.28-.39-.76-.59-1.23-.53h-1.25v4.23h1.25c.61.02,1.15-.36,1.34-.94.15-.39.22-.81.21-1.23.03-.53-.08-1.05-.31-1.52ZM52.09,24.78h-.74l-.71-2.36v2.36h-.87v-3.26h1.35l.59,1.88.58-1.88h1.35v3.26h-.87v-2.37l-.71,2.36ZM46.61,22.3v-.78h2.88v.78h-.97v2.48h-.95v-2.48h-.96ZM18.84,37v-2.89h-2.53v2.89h-1.34v-6.48h1.34v2.47h2.53v-2.47h1.35v6.48h-1.35ZM24.07,37.18c-.78.05-1.55-.22-2.12-.76-.69-.71-1.05-1.68-.98-2.67-.08-.99.28-1.97.98-2.67.57-.54,1.34-.81,2.12-.76.78-.05,1.55.22,2.12.76.7.71,1.06,1.68.98,2.67.07.99-.29,1.96-.98,2.67-.57.54-1.34.81-2.12.76ZM25.35,35.44c.34-.49.51-1.09.47-1.69.04-.6-.13-1.19-.47-1.68-.3-.39-.78-.62-1.28-.6-.5-.02-.97.2-1.28.59-.35.49-.52,1.09-.48,1.69-.04.6.13,1.2.48,1.69.31.39.79.61,1.28.59.5.02.97-.2,1.28-.59ZM32.64,30.52v1.15h-1.94v5.33h-1.36v-5.33h-1.94v-1.15h5.24ZM37.67,34.17h-3.15v1.66h3.59v1.16h-4.91v-6.48h4.75v1.15h-3.42v1.38h3.15v1.12ZM38.9,30.52h1.35v5.31h3.21v1.16h-4.56v-6.48Z" fill="#fff" stroke-width="0"/></svg>'

  const defaultPinSvg = '<svg class="w-[1.425rem]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.38 36.45"><ellipse cx="12.6" cy="12.88" rx="5" ry="5.5" fill="#fff" stroke-width="0"/><path d="M12.69,1.5C6.51,1.5,1.5,6.51,1.5,12.69c0,0,0,0,0,0,.08,2.76.95,5.43,2.5,7.71,2.43,3.75,8.69,13.31,8.69,13.31,0,0,6.26-9.55,8.69-13.31,1.55-2.28,2.42-4.96,2.5-7.72,0-6.18-5.01-11.19-11.19-11.18,0,0,0,0,0,0M12.69,18.94c-3.45,0-6.26-2.8-6.26-6.26s2.8-6.26,6.26-6.26,6.26,2.8,6.26,6.26h0c0,3.45-2.8,6.26-6.26,6.26" fill="#fff" stroke="#222" stroke-width="3"/></svg>'
  const focusPinSvg = '<svg class="w-[2.6125rem]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 41.35 59.45"><ellipse id="uuid-67faddfa-6d99-4e72-ab54-e4a6007172b8" data-name="楕円形 262" cx="20.67" cy="22.18" rx="10.57" ry="11.93" fill="#fff" stroke-width="0"/><path id="uuid-915730ab-9a76-4d23-9749-abfd355133ba" data-name="パス 109468" d="M20.67,1.5C10.08,1.5,1.5,10.08,1.5,20.67c0,0,0,0,0,0,.13,4.73,1.62,9.32,4.28,13.23,4.17,6.44,14.89,22.81,14.89,22.81,0,0,10.73-16.38,14.89-22.81,2.66-3.91,4.15-8.5,4.28-13.23,0-10.59-8.58-19.17-19.17-19.18,0,0,0,0,0,0M20.67,31.4c-5.92,0-10.72-4.8-10.72-10.73,0-5.92,4.8-10.72,10.73-10.72,5.92,0,10.71,4.8,10.72,10.72,0,5.92-4.8,10.72-10.72,10.73,0,0,0,0,0,0" fill="#faf500" stroke="#222" stroke-width="3"/></svg>';

  if (musterdPin) {
    const pin = document.createElement('div');
    pin.innerHTML = musterdPin;

    const marker = new AdvancedMarkerElement({
      map: map,
      position: { lat: 35.66459028082753, lng: 139.6713481418349 },
      content: pin,
    });

    marker;
  }

  placeData.forEach((place, index) => {
    const lat = Number(place.getAttribute('data-lat'));
    const lng = Number(place.getAttribute('data-lng'));

    const pin = document.createElement('div');
    pin.innerHTML = defaultPinSvg;

    const marker = new AdvancedMarkerElement({
      map: map,
      position: { lat, lng },
      content: pin,
    });

    const placeParent = place.closest('.js-place-block') as HTMLElement;

    if (index === 0 && placeParent) {
      const placeName = placeParent.querySelector('.js-place-name') as HTMLElement;
      const placeTitle = placeParent.querySelector('.js-place-title') as HTMLAnchorElement;
      const placeThumbnail = placeParent.querySelector('.js-place-thumbnail') as HTMLImageElement;

      const thumbnailDataSrc = placeThumbnail.getAttribute('data-src');
      const thumbnailUrl = thumbnailDataSrc ? thumbnailDataSrc : placeThumbnail.src;

      if (pinName) {
        pinName.textContent = placeName.textContent;
      }

      if (pinTitle) {
        pinTitle.innerHTML = `<a class="line-clamp-2 before:absolute before:inset-0" href="${placeTitle.href}">${placeTitle.textContent}</a>`;
      }

      if (pinThumbnail) {
        pinThumbnail.innerHTML = `<img class="absolute top-0 left-0 w-full h-full object-cover object-center" src="${thumbnailUrl}" alt="${placeThumbnail.alt}">`;
      }
    }

    markers.push(marker);

    marker.addListener('click', () => {
      markers.forEach(m => {
        const defaultPin = document.createElement('div');
        defaultPin.innerHTML = defaultPinSvg;

        m.content = defaultPin;
      });

      const focusPin = document.createElement('div');
      focusPin.innerHTML = focusPinSvg;

      marker.content = focusPin;

      const activePlace = document.querySelector('.js-place-data.is-active') as HTMLElement;

      if (activePlace) {
        activePlace.classList.remove('is-active');
      }

      const place = placeParent.querySelector('.js-place-data') as HTMLElement;
      place.classList.add('is-active');

      const placePos = placeParent.getBoundingClientRect().top + window.scrollY;

      const placeName = placeParent.querySelector('.js-place-name') as HTMLElement;
      const placeTitle = placeParent.querySelector('.js-place-title') as HTMLAnchorElement;

      const placeThumbnail = placeParent.querySelector('.js-place-thumbnail') as HTMLImageElement;

      if (pinName) {
        pinName.textContent = placeName.textContent;
      }

      if (pinTitle) {
        pinTitle.innerHTML = `<a class="line-clamp-2 before:absolute before:inset-0" href="${placeTitle.href}">${placeTitle.textContent}</a>`;
      }

      if (pinThumbnail) {
        pinThumbnail.innerHTML = `<img class="absolute top-0 left-0 w-full h-full object-cover object-center" src="${placeThumbnail.src}" alt="${placeThumbnail.src}">`;
      }

      window.scrollTo({
        top: placePos,
        behavior: 'smooth',
      });
    });

    place.addEventListener('click', () => {
      const lat = Number(place.getAttribute('data-lat'));
      const lng = Number(place.getAttribute('data-lng'));

      const activePlace = document.querySelector('.js-place-data.is-active') as HTMLElement;

      if (activePlace) {
        activePlace.classList.remove('is-active');
      }

      place.classList.add('is-active');

      const placeParent = place.closest('.js-place-block') as HTMLElement;

      const placeName = placeParent.querySelector('.js-place-name') as HTMLElement;
      const placeTitle = placeParent.querySelector('.js-place-title') as HTMLAnchorElement;

      const placeThumbnail = placeParent.querySelector('.js-place-thumbnail') as HTMLImageElement;

      if (pinName) {
        pinName.textContent = placeName.textContent;
      }

      if (pinTitle) {
        pinTitle.innerHTML = `<a class="line-clamp-2 before:absolute before:inset-0" href="${placeTitle.href}">${placeTitle.textContent}</a>`;
      }

      if (pinThumbnail) {
        pinThumbnail.innerHTML = `<img class="absolute top-0 left-0 w-full h-full object-cover object-center" src="${placeThumbnail.src}" alt="${placeThumbnail.src}">`;
      }

      markers.forEach(m => {
        const defaultPin = document.createElement('div');
        defaultPin.innerHTML = defaultPinSvg;

        m.content = defaultPin;
      });

      const focusPin = document.createElement('div');
      focusPin.innerHTML = focusPinSvg;

      marker.content = focusPin;

      const newPosition = { lat: lat, lng: lng };
      map.setCenter(newPosition);
    });
  });
}

export { initMap };
